export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "badge": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Challenge en cours · ", _interpolate(_named("title"))])},
        "top_reward_amount": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Jusqu'à ", _interpolate(_named("reward")), " à gagner en ce moment"])},
        "top_reward_label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("reward")), " à gagner en ce moment"])},
        "see_details": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir le détail"])}
      },
      "en": {
        "badge": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Challenge running · ", _interpolate(_named("title"))])},
        "top_reward_amount": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Up to ", _interpolate(_named("reward")), " to win right now"])},
        "top_reward_label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("reward")), " to win right now"])},
        "see_details": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["See the details"])}
      }
    }
  })
}
